import {OrderProcessPhase, ProcessingStep, ProcessingStepType} from '../constants'

export function getNextStep<T extends string>(
    steps: T[],
    currentStep: T,
    defaultStep: T,
): T | typeof ProcessingStep.FINISH {
    if (currentStep === defaultStep) {
        return defaultStep
    }
    const index = steps.findIndex((step) => step === currentStep)
    if (index > -1) {
        return steps[index + 1] ?? ProcessingStep.FINISH
    }
    return defaultStep
}

export function goNextStep(step: ProcessingStepType) {
    const phase = (function () {
        if (step === ProcessingStep.FINISH) {
            return OrderProcessPhase.FINISH
        }
        if (step === ProcessingStep.APPLYING) {
            return OrderProcessPhase.PROCESSING
        }
        return OrderProcessPhase.START
    })()
    return {
        processStep: step,
        phase,
    }
}
